import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useState } from 'react';
import { DemGtnSummaryGrid, SCALES } from './DemGtnSummaryGrid';

export const DemGtnSummaryGridCard = () => {
  const [scaleKey, setScaleKey] = useState('MILLIONS');

  const scaleToggle = (
    <ToggleButtonGroup
      exclusive
      value={scaleKey}
      onChange={(event, value) => value && setScaleKey(value)}
      sx={{ height: 40 }}
    >
      {Object.entries(SCALES).map(([key, scale]) => (
        <ToggleButton key={key} value={key} sx={{ px: 1.5, py: 0.25 }}>
          {scale.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );

  return (
    <DashboardCard
      title="Gross-to-Net Summary"
      description="Gross Sales, deductions grouped by channel, Total Deductions, Net Sales, and any available key metrics such as GTN %, units, discount per unit, and average net sales price. Its columns are a Total plus either the top products or the periods, each split into amounts and their percent of that column's gross sales."
      buttons={scaleToggle}
    >
      {/* The Grid only reads its formatters on mount, so changing the scale remounts it */}
      {(data) => <DemGtnSummaryGrid key={scaleKey} data={data} scaleKey={scaleKey} />}
    </DashboardCard>
  );
};
